export enum Width {
    SMALL = 'small',
    FULL = 'full'
}

export default Width;
